import React from 'react'
import { useTranslation } from 'react-i18next'
import { animated } from 'react-spring'
import { useDropDown } from '~/hooks/dropdown'

import { accountPath, contactPath } from '~/common/define/path'
import { ChildProps } from '~/common/define/props'
import { logout } from '~/common/define/logout'
import RowList, { RowListScroll } from '~/components/atoms/row/RowList'
import Row from '~/components/atoms/row/Row'
import RowLink from '~/components/atoms/row/RowLink'
import TooltipWrapper from '~/components/wrapper/tooltip/TooltipWrapper'
import { SupportUrl } from '~/common/define/url'

interface Props extends ChildProps {
  isOrigin: boolean
}

const SettingDropdown = ({children, isOrigin}: Props) => {
  const {t} = useTranslation()
  const {clickableRef, onClickOpen, open, dropDownStyles, dropDownClass} = useDropDown()
  return (
    <button onClick={onClickOpen} ref={clickableRef}>
      <TooltipWrapper text={t('header:tooltip.setting')} off={open}>
        {children}
      </TooltipWrapper>
      {dropDownStyles &&
        <animated.div style={dropDownStyles} className={dropDownClass}>
          <RowList scroll={RowListScroll.NO} noBorder>
            <Row clickable>
              <RowLink link={accountPath()}>
                {t('header:self_setting')}
              </RowLink>
            </Row>
            {!isOrigin &&
              <>
                <Row clickable>
                  <RowLink link={SupportUrl.TOP_HEADER} external>
                    {t('support_site')}
                  </RowLink>
                </Row>
                <Row clickable>
                  <RowLink link={contactPath()} external>
                    {t('header:contact')}
                  </RowLink>
                </Row>
              </>
            }
            <Row clickable>
              <RowLink onClick={() => logout()}>
                {t('header:logout')}
              </RowLink>
            </Row>
          </RowList>
        </animated.div>
      }
    </button>
  )
}

export default SettingDropdown
